const QuestionMarkIcon = ({
  className
}: {
  className?: string;
}) => {
  return <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' className={className} data-sentry-element="svg" data-sentry-component="QuestionMarkIcon" data-sentry-source-file="QuestionMarkIcon.tsx">
      <circle cx='12' cy='12' r='10' data-sentry-element="circle" data-sentry-source-file="QuestionMarkIcon.tsx" />
      <path d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' data-sentry-element="path" data-sentry-source-file="QuestionMarkIcon.tsx" />
      <path d='M12 17h.01' data-sentry-element="path" data-sentry-source-file="QuestionMarkIcon.tsx" />
    </svg>;
};
export default QuestionMarkIcon;